import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PageTopTitle from '../../components/shared/PageTopTitle'
import styled from 'styled-components'

import { getYukbulBlockingMessages, setBlockingMessageFilterItem, setBlockingMessageFilterText, setBlockingMessageFilterType } from '../../features/admin5/admin5Slice'
import { showModal } from '../../features/modal/modalSlice'
import Btn from '../../components/shared/button/Btn'
import InputText from "../../components/shared/input/new/InputText"
import InputSelect from "../../components/shared/input/new/InputSelect"
const Container = styled.div`
width: 100%;

.wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

      .content{
        gap: 60px;
        margin: 50px 30px;
        width: calc(100% - 60px);
        
        .top-container{
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin: 20px 0;

          .filter-container{
            display: flex;
            gap: 40px;
          }
        }

        .filter-list{
          display: flex;
          gap: 15px;
          flex-wrap: wrap;
          width: 100%;


          .filter-item{
            width: calc(33.33% - 10px);
            background-color: ${({theme}) => theme.secondaryBgColor};
            border-radius: 10px;
            font-size: var(--font-size-sm);
            color: ${({theme}) => theme.mainTextColor};
            padding: 20px 15px;
            cursor: pointer;
            font-weight: var(--font-weight-lg);
            display: flex;
            justify-content: space-between;
            align-items: center;

            &:hover{

                .item-action{
                  display: block;
                }

              }

            .item-content{
              display: flex;
              flex-direction: column;
              gap: 5px;

              .text{

              }

              .type{
                color: var(--color-main);

              }
            }

            .item-action{
              display: none;

              &:Hover{
                text-decoration: underline;
              }
            }
          }
        }
    }
}
`

const filterTypeOptions = [
  {
    value: 0,
    text: "Tümü"
  },
  {
    value: 1,
    text: "Yazı Engellemeleri"
  },
  {
    value: 2,
    text: "Telefon Numarası Engellemeleri"
  },
]

const YukBulMessageBlocking = () => {

    const dispatch = useDispatch()


    const [blockingMessageFilterType, setBlockingMessageFilterType] = useState({
      value:0,
      text: "Tümü"
    })
    const [blockingMessageFilterText, setBlockingMessageFilterText] = useState("")

    const {
      yukbulBlockingMessagesList,
    } = useSelector(state => state.admin5)

    useEffect(() => {
      setBlockingMessageFilterText("")
    },[blockingMessageFilterType.value])

    useEffect(() => {
      dispatch(getYukbulBlockingMessages({blockingMessageFilterText, blockingMessageFilterType}))
    },[blockingMessageFilterText, blockingMessageFilterType.value])

  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Yük Bul Mesaj Engelleme"} position='sticky'/>
        <div className="content">
          <div className="top-container">
            <div className="filter-container">
              <InputSelect data={blockingMessageFilterType.text} setData={(item) => setBlockingMessageFilterType(item)} initialOptions={filterTypeOptions} labelText={"Engel Türü"} inputWidth={"280px"} name={"yukBulFilterType"}/>
              <InputText data={blockingMessageFilterText} setData={(e) => setBlockingMessageFilterText(blockingMessageFilterType.value === 2 ? e.target.value.replace(/[^0-9]/g, '').replace(/^0/, "") : e.target.value)} labelText={`Engelli Mesaj Ara${blockingMessageFilterType.value === 0 ? "" : blockingMessageFilterType.value === 1 ? " (Yazıya Göre)" : " (Telefon Numarasına Göre)"}`} inputWidth={"300px"}/>
            </div>
          <Btn bgColor="#E85446" color="#fff" handleClick={() => dispatch(showModal("addYukBulBlockingMessage"))} width={"180px"}>Yeni Mesaj Engelle</Btn>
          </div>
          <div className="filter-list">
            {
              yukbulBlockingMessagesList.map(item => (
                <div className="filter-item">
                  <div className="item-content">
                    <div className="text">{item.filterValue}</div>
                    <div className='type'>({item.filterType === 1 ? "Yazı" : "Telefon Numarası"})</div>
                  </div>
                  <btn className="item-action" onClick={() => {dispatch(showModal("deleteYukbulBlockingMessageConfirm")); dispatch(setBlockingMessageFilterItem(item))}}>Sil</btn>
                  </div>
              ))
            }
          </div>
        </div>

    </div>
  </Container>
  )
}

export default YukBulMessageBlocking